/**
 * @desc 订单已退金额查询
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.calcRefundAmount.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/calcRefundAmount`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
